// extracted by mini-css-extract-plugin
export default {"suggestion-body-header":"fEioMdii","autocomplete":"UiHJuMTp","suggestions-list":"AWHsrcXM","suggestions-options":"rXZAC40w","suggestions-none":"eVbccrqV"};